<div class="modal-header">
  <h3 uni-heading color="primary" class="modal-title">
    {{ title }}
  </h3>

  <button uni-icon-button variant="muted" aria-label="Cerrar" (click)="closeMe()">
    <uni-icon name="x"></uni-icon>
  </button>
</div>
<div class="modal-body">
  <p class="modal-text">{{ text }}</p>
  <div class="radio-list" *ngIf="!showInstructions">
    <uni-radio-group [(ngModel)]="selectProfileBind">
      <uni-radio-button
        (checked)="confirm($event)"
        *ngFor="let profile of profileList"
        [value]="profile.perfilId"
        styleVariant="modern"
        [checkedValue]="selectProfileBind"
        [name]="profile.perfil.nombre"
        >{{ profile.perfil.nombre }}</uni-radio-button
      >
    </uni-radio-group>
  </div>
  <img
    id="profile-selection"
    *ngIf="showInstructions"
    src="../../../../assets/images/select-profile.png"
    alt="selecting profile image"
  />
</div>
